import { GetApp, Publish, ViewColumn } from "@mui/icons-material";
export default [
    {
        label: "download",
        Icon: GetApp,
        action: "onDownload"
    },
    {
        label: "template",
        Icon: ViewColumn,
        action: "onTemplate"
    },
    {
        label: "upload",
        Icon: Publish,
        action: "onUpload"
    }
];
